<template>
  <div class="background-wrapper-other">
    <div class="breadcrumb">
      <div class="container">
        <ul>
            <li><router-link to="/">HARUMIFLAG</router-link></li>
            <li><router-link to="/shop-news">ショップニュース一覧</router-link></li>
        </ul>
      </div>
    </div>
    <div class="shopnew">
      <ShopNewsListKeyword />
    </div>
  </div>
</template>

<script>
import { RouterLink } from "vue-router";
import { metaData } from '@/utils/helper';

export default {
  name: "ShopNews",
  components: {
    ShopNewsListKeyword: () => import("@/components/common/shop/ShopNewsListKeyword.vue"),
  },
  computed: {},
  created() {
    metaData(
      `ショップニュース | HARUMIFLAGタウンポータル`,
      '中央区晴海・HARUMIFLAGのショップニュース一覧です。ショップからのおすすめ情報をお知らせします。',
      'HARUMIFLAGタウンポータル',
      'blog',
    )
  },
};
</script>

  